import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Container from "@material-ui/core/Container";
import TableBody from "@material-ui/core/TableBody";
import Grid from "@material-ui/core/Grid";
const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 650,
  },
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
    overflowX: "auto",
    flexGrow: 1,
    display: "flex",
    justifyContent: "flex-start",
  },
  bg: {
    display: "flex",
    justifyContent: "flex-start",
  },
}));

export default function AddUserReview(props) {
  const classes = useStyles();
  const { addUserData } = props;

  return (
    <div>
      <h2>Review</h2>
      <Container component="main" maxWidth="lg">
        <Grid
          container
          spacing={3}
          style={{ display: "flex", justifyContent: "center" }}
        >
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>User</TableCell>
                <TableCell>Pharmacy</TableCell>
                <TableCell>New License</TableCell>
                <TableCell>Role</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {addUserData.selectstores.map((row, i) => {
                const availableRole = addUserData.roles.find(
                  (role) => role.storepk === row.storepk
                )
                  ? 1
                  : 0;
                return (
                  <TableRow key={i}>
                    <TableCell>{`${addUserData.firstname} ${addUserData.lastname}`}</TableCell>
                    <TableCell>{row.storename}</TableCell>
                    <TableCell>{availableRole}</TableCell>
                    <TableCell>{addUserData.roles[i]?.roletype}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Grid>
      </Container>
    </div>
  );
}
